import { useState, useEffect } from 'react';

export function useGlassmorphism() {
    const [glassmorphismEnabled, setGlassmorphismEnabled] = useState(() => {
        const saved = localStorage.getItem('glassmorphism-enabled');
        return saved !== null ? saved === 'true' : true;
    });

    useEffect(() => {
        const checkGlassmorphism = () => {
            const saved = localStorage.getItem('glassmorphism-enabled');
            const current = saved !== null ? saved === 'true' : true;
            if (current !== glassmorphismEnabled) {
                setGlassmorphismEnabled(current);
            }
        };

        // Check every 100ms for changes
        const interval = setInterval(checkGlassmorphism, 100);

        return () => clearInterval(interval);
    }, [glassmorphismEnabled]);

    return glassmorphismEnabled;
}
